module.exports = __webpack_public_path__ + "static/media/Artboard_40_4x.20d320ab.png";